"use client";

import { useEffect, Suspense } from "react";
import { useSearchParams } from "next/navigation";

function SearchHighlighterContent() {
  const searchParams = useSearchParams();

  useEffect(() => {
    const highlightText = searchParams.get("highlight");

    if (!highlightText || !highlightText.trim()) {
      return;
    }

    const searchTerm = highlightText.trim();

    // 이전 하이라이팅 제거
    document.querySelectorAll(".search-highlight").forEach((el) => {
      const parent = el.parentNode;
      if (parent) {
        parent.replaceChild(document.createTextNode(el.textContent || ""), el);
        parent.normalize();
      }
    });

    // 텍스트 노드를 찾아서 하이라이팅
    const highlightInElement = (element: Element): boolean => {
      let found = false;
      const walker = document.createTreeWalker(
        element,
        NodeFilter.SHOW_TEXT,
        null
      );

      const textNodes: Text[] = [];
      let node;
      while ((node = walker.nextNode())) {
        textNodes.push(node as Text);
      }

      textNodes.forEach((textNode) => {
        const content = textNode.textContent || "";
        const regex = new RegExp(`(${searchTerm})`, "gi");

        if (regex.test(content)) {
          found = true;
          const highlightedHTML = content.replace(
            regex,
            '<mark class="search-highlight bg-yellow-300 dark:bg-yellow-600 px-1 rounded">$1</mark>'
          );

          const wrapper = document.createElement("span");
          wrapper.innerHTML = highlightedHTML;

          textNode.parentNode?.replaceChild(wrapper, textNode);
        }
      });

      return found;
    };

    // 메인 콘텐츠 영역에서 검색
    const contentSelectors = [
      "article",
      "main",
      ".prose",
      "[data-mdx-content]",
      ".content",
    ];

    for (const selector of contentSelectors) {
      const element = document.querySelector(selector);
      if (element && highlightInElement(element)) {
        break;
      }
    }

    // 첫 번째 하이라이트된 요소로 스크롤
    setTimeout(() => {
      const firstHighlight = document.querySelector(".search-highlight");
      if (firstHighlight) {
        firstHighlight.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });

        // 5초 후 하이라이팅 제거
        setTimeout(() => {
          document.querySelectorAll(".search-highlight").forEach((el) => {
            const parent = el.parentNode;
            if (parent) {
              parent.replaceChild(
                document.createTextNode(el.textContent || ""),
                el
              );
              parent.normalize();
            }
          });
        }, 5000);
      }
    }, 100);
  }, [searchParams]);

  return null;
}

export default function SearchHighlighter() {
  return (
    <Suspense fallback={null}>
      <SearchHighlighterContent />
    </Suspense>
  );
}
